import styled, { useTheme } from 'styled-components'

import { GetVaultMetricsHistoryIntervalType } from '@/shared/backend/types'

import { CustomLegend } from './Legend'
import { Button } from 'components/Button/Button'
import { GraphTypes } from './ApyTvlCharts'

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding: 0 40px;
  position: relative;
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    flex-direction: column;
    gap: 12px;
  }
`
const IntervalButton = styled(Button)<{ disabled?: boolean }>`
  font-size: 12px;
  padding: 8px 12px;
`

interface Props {
  interval: GetVaultMetricsHistoryIntervalType
  setInterval: (interval: GetVaultMetricsHistoryIntervalType) => void
  disabled?: boolean
  filters: Record<string, boolean>
  handleFilterClick: (filterName: string) => void
}

export const Header = ({ interval, setInterval, disabled, filters, handleFilterClick }: Props) => {
  const theme = useTheme()

  return (
    <HeaderContainer>
      <CustomLegend
        payload={[
          { value: GraphTypes.Tvl, color: theme.colors.button.background, isActive: filters[GraphTypes.Tvl] },
          { value: GraphTypes.Apy, color: theme.colors.text.danger2, isActive: filters[GraphTypes.Apy] },
        ]}
        onClick={handleFilterClick}
        disabled={disabled}
      />

      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        <IntervalButton outlined={interval !== '24h'} onClick={() => setInterval('24h')} disabled={disabled}>
          24h
        </IntervalButton>
        <IntervalButton outlined={interval !== '7d'} onClick={() => setInterval('7d')} disabled={disabled}>
          7d
        </IntervalButton>
        <IntervalButton outlined={interval !== '30d'} onClick={() => setInterval('30d')} disabled={disabled}>
          30d
        </IntervalButton>
        <IntervalButton outlined={interval !== '3m'} onClick={() => setInterval('3m')} disabled={disabled}>
          3m
        </IntervalButton>
      </div>
    </HeaderContainer>
  )
}
